import { Box, Grid, Typography } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GlassCard from "../General/GlassCard";
import CardHeader from "../General/CardHeader";
import LegalFileSearch from "../General/LegalFileSearch";

export default function SearchLegalFile() {
  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 10, lg: 10 }}>
        <GlassCard>
          <CardHeader
            icon={<AssignmentIcon />}
            title="Buscar Expediente"
            description="Buscá por código o nombre y abrí el expediente en una pestaña nueva."
          />

          <Box sx={{ px: { xs: 0, sm: 1 }, pb: 1 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: 13.5, mb: 0.8, ml: 0.5 }}
            >
              Código o nombre del expediente
            </Typography>

            <LegalFileSearch autoFocus />

            <Typography
              variant="caption"
              sx={{ opacity: 0.6, display: "block", mt: 1.2, ml: 0.5 }}
            >
              Escribí al menos 2 caracteres. Los resultados aparecen a medida que
              tipeás; al seleccionar uno se abre el detalle en otra pestaña.
            </Typography>
          </Box>
        </GlassCard>
      </Grid>
    </Grid>
  );
}
